export default __webpack_public_path__ + "static/media/36I-102764_-15876_0.0ff59765.jpg";